"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currentEmploymentStatus = void 0;
const enums_1 = require("@bemlo/enums");
exports.currentEmploymentStatus = {
    [enums_1.CurrentEmploymentStatus.EMPLOYED]: 'Jeg er fast ansatt',
    [enums_1.CurrentEmploymentStatus.UNDER_NOTICE]: 'Oppsagt',
    [enums_1.CurrentEmploymentStatus.IN_STAFFING]: 'Jeg leter etter arbeid',
};
